import React, { createContext, useState, useEffect } from "react";
import { getData } from "../services/API";
import { useContext } from "react";
import { UserData } from "./UserInfoContext";
import { getItemStorage } from "../Localstorage/useLocalStorage";

export const favouriteListContext = createContext();

const FavouriteContext = ({ children }) => {
  const { user } = useContext(UserData);

  const [favouriteList, setFavouriteList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notLogin, setNotLogin] = useState(false);

  const token = getItemStorage("token");
  useEffect(() => {
    token &&
      getData("/user/get-favorites", {})
        .then((res) => {
          setFavouriteList(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });

    !token && setNotLogin(true);
  }, []);

  return (
    <favouriteListContext.Provider value={{ favouriteList, setFavouriteList, notLogin }}>
      {children}
    </favouriteListContext.Provider>
  );
};

export default FavouriteContext;
